import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPersonWalkingDashedLineArrowRight } from "@fortawesome/free-solid-svg-icons";
import { Divider } from "@mui/material";
import { useTranslation } from "react-i18next";

const NotFound: React.FC = () => {
  const { t } = useTranslation("access");

  return (
    <div className="flex flex-col min-h-0">
      <div className="pb-8 flex-grow flex items-center justify-center bg-theme-bg lg:py-8">
        <div className="bg-theme-surface-2 p-5 shadow-md shadow-theme-shadow w-full min-h-48 flex flex-col justify-center items-center lg:max-w-xl lg:p-12 lg:rounded-lg">
          <FontAwesomeIcon icon={faPersonWalkingDashedLineArrowRight} className="text-6xl text-theme-warning mb-4" />
          <h2 className="text-3xl font-semibold text-center text-theme-text mb-6">{t("notFound.title")}</h2>
          <Divider className="!mb-6 w-full max-w-12 mx-auto bg-theme-text-muted" />
          <p className="text-lg text-center mb-4 text-theme-text">{t("notFound.body")}</p>
        </div>
      </div>
    </div>
  );
};

export default NotFound;